import {emptyValidator, formValidator} from "../../validators";

export const workOrderVendorValidation = (data) => {
    const vendorValidationStatus = {
        selectedVendor: {
            validators: [emptyValidator()],
            name: "Vendor",
        }
    };

    return formValidator(data, vendorValidationStatus);
};

export const workOrderCreationValidation = (data) => {
    const workOrderValidationStatus = {
        fwoVehicle: {
            validators: [emptyValidator()],
            name: "Vehicle",
        },
        fwoExpectedCompletionDate: {
            validators: [emptyValidator()],
            name: "Expected Completion Date",
        },
        fwoStatus: {
            validators: [emptyValidator()],
            name: "Active",
        },
        fwoActive: {
            validators: [emptyValidator()],
            name: "Status",
        },
        ...(data.fwoRepairPriority === 1 && {
            fwoScheduledStatrtTime: {
                validators: [emptyValidator()],
                name: "Scheduled Start Date & Time",
            },
        }),
        ...(data.fwoStartDateReminder === true && {
            fwoNotifyUser: {
                validators: [emptyValidator()],
                name: "User",
            },
            fwoAlertType: {
                validators: [emptyValidator()],
                name: "Alert Type",
            },
        }),
        ...((data.fwoStatus === 3 || data.fwoStatus === 4 )&& {
            fwoActualCompletionDate: {
                validators: [emptyValidator()],
                name: "Actual Completion Date",
            },
        }),
    };

    return formValidator(data, workOrderValidationStatus);
};